import { Flex, Text } from "@engaging-tech/components"
import React from "react"
import styled from "styled-components"

import { ReactComponent as InstagramLogo } from "../../../assets/icons/logos/instagram-logo-icon.svg"
import { ReactComponent as LinkedinLogo } from "../../../assets/icons/logos/linkedin-logo-icon.svg"
import { ReactComponent as TiktokLogo } from "../../../assets/icons/logos/tiktok-logo-icon.svg"
import { ReactComponent as XLogo } from "../../../assets/icons/logos/x-logo-icon.svg"

const styledLogoIcon = Icon => styled(Icon)`
  width: 30px;
  height: 30px;
  opacity: 0.8;
  transition: transform 0.3s ease, opacity 0.3s ease;

  &:hover {
    transform: scale(1.1);
    opacity: 1;
  }
  @media (max-width: 768px) {
    width: 28px;
    height: 28px;
  }
`

const LinkedinIcon = styledLogoIcon(LinkedinLogo)
const InstagramIcon = styledLogoIcon(InstagramLogo)
const XLogoIcon = styledLogoIcon(XLogo)
const TiktokIcon = styledLogoIcon(TiktokLogo)

const socialMediaLinks = [
  {
    name: "instagram logo",
    url: "https://www.instagram.com/happy.workplaces/",
    Icon: <InstagramIcon />
  },
  {
    name: "X Logo",
    url: "https://x.com/happyworkplace_",
    Icon: <XLogoIcon />
  },
  {
    name: "linkedin logo",
    url: "https://www.linkedin.com/company/worlds-happiest-workplaces",
    Icon: <LinkedinIcon />
  },
  {
    name: "tiktok icon",
    url: "https://www.tiktok.com/@happy.workplaces?lang=en",
    Icon: <TiktokIcon />
  }
]

const SocialLinkContainer = styled(Flex)`
  margin-bottom: 10px;
  width: 100%;
  justify-content: center;
`

const SocialLink = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  margin-right: 12px;
`
export default function SocialsBanner() {
  return (
    <Flex alignItems="center" flexDirection="column">
      <Text
        fontSize={[5, 7]}
        fontWeight={600}
        textAlign="center"
        color="primary.0"
        width="auto"
        fontFamily="Tiempos"
        mb={[0, 4, 4]}
      >
        Stay connected
      </Text>
      <SocialLinkContainer>
        {socialMediaLinks.map(item => (
          <SocialLink key={item.name} onClick={() => window.open(item.url, "_blank")}>
            {item.Icon}
          </SocialLink>
        ))}
      </SocialLinkContainer>
    </Flex>
  )
}
